export const fonts = {
	heading: "'Poppins', sans-serif",
	body: "'Poppins', sans-serif",
}
